
export const LIST_COMUMNES: { value: string, text: string }[] = [
    {
        value: "Chillán Viejo",
        text: "Chillán Viejo (Km 410-420 aprox.)"
    },
    {
        value: "Bulnes",
        text: "Bulnes (Km 420-440 aprox.)"
    },
    {
        value: "Pemuco",
        text: "Pemuco (Km 440-450 aprox.)"
    },
    {
        value: "Cabrero",
        text: "Cabrero (Km 450-480 aprox.)"
    },
    {
        value: "Los Ángeles",
        text: "Los Ángeles (Km 480-530 aprox.)"
    },
    {
        value: "Mulchén",
        text: "Mulchén (Km 530-550 aprox.)"
    },
    {
        value: "Collipulli",
        text: "Collipulli (Km 550-580 aprox.)"
    },
];

export const VALIDATION_RANGE_COMMUNE = {
    "Chillán Viejo": {
        min: 410,
        max: 419
    },
    "Bulnes": {
        min: 420,
        max: 439
    },
    "Pemuco": {
        min: 440,
        max: 449
    },
    "Cabrero": {
        min: 450,
        max: 479
    },
    "Los Ángeles": {
        min: 480,
        max: 529
    },
    "Mulchén": {
        min: 530,
        max: 549
    },
    "Collipulli": {
        min: 550,
        max: 580
    },
}